import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { NewsDetailsSchema } from "../../schema";

import { AddNewNews } from "../../api";
import { useSelector } from "react-redux";
import ImageCropUpload from "../common/ImageCropUpload";

const initialValues = {
  // ProfileDetails
  image: "",
  title: "",
  content: "",
  link: "",
};

const AddNews = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [isLoading, setIsLoading] = useState(false);
  //  const [serviceData, setServiceData] = useState(null);
  const toast = useRef(null);

  const addNewsHandler = async (values, action) => {
    const formData = new FormData();
    formData.append("image", values.image);
    formData.append("title", values.title);
    formData.append("content", values.content);
    formData.append("link", values.link);

    await AddNewNews(formData, token)
      .then((res) => {
        setIsLoading(true);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        action.resetForm();
        setTimeout(() => {
          setIsLoading(false);
          navigate("/news-management");
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    handleBlur,
    submitCount,
  } = useFormik({
    initialValues,
    validationSchema: NewsDetailsSchema(),
    onSubmit: (values, action) => addNewsHandler(values, action),
  });

  useEffect(() => {
    async function getAllAPI() {}
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  const validationMessages = Object.values(errors).filter(Boolean);

  return (
    <>
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />
      <form onSubmit={handleSubmit} className="">
        <div className="news-details-cls-portion mt-4">
          {submitCount > 0 && validationMessages.length > 0 && (
            <div className="alert alert-danger" role="alert">
              <strong>Please complete these fields:</strong>{" "}
              {validationMessages.join(", ")}
            </div>
          )}
          <div className="event-details-all-starting-part">
            <div className="userprofile-pics">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <path
                      d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                      fill="black"
                    />
                  </svg>
                  <h6 className="mb-0">Back to news details</h6>
                </div>
              </div>
            </div>

            <div className="main-profile-all-cls-start mt-4">
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-4 position-relative">
                    <label className="my-2">
                      Upload image:-
                      <span className="required">
                        {" "}
                        Crop will be saved as 300w X 280h
                      </span>
                    </label>
                    <ImageCropUpload
                      name="image"
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      error={errors.image}
                      touched={touched.image}
                    />
                    <span className="upload-all-btns-cls-add"></span>
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">
                      Title<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput2"
                      placeholder="Please Enter Title Here"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.title && touched.title ? (
                      <p className="form-error">{errors.title}</p>
                    ) : null}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-8">
                    <label className="my-2">Link</label>
                    <input
                      type="link"
                      className="form-control"
                      id="exampleFormControlInput2"
                      name="link"
                      placeholder="Please Enter this Link"
                      value={values.link}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.link && touched.link ? (
                      <p className="form-error">{errors.link}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-8">
                    <label className="my-2">
                      Content<span className="required">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Please Enter Content Here"
                      name="content"
                      id="floatingTextarea"
                      value={values.content}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {errors.content && touched.content ? (
                      <p className="form-error">{errors.content}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-8">
                    <div className="right-sidebtn-add text-end">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary outline-btn-cls me-3"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary filled-btn-cls"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddNews;
